import {Component, OnInit} from '@angular/core';
import {InvitationResponse} from '../../models/invitationResponse';
import {InvitationService} from '../../services/invitation/invitation.service';
import {UiToastService} from '../../shared/ui';
import {ActivatedRoute, Router} from '@angular/router';
import { AppLogger, AppLoggerService } from '../../core/logging';

@Component({
    selector: 'app-invitation-handler',
    templateUrl: './invitation-handler.component.html',
    styleUrls: ['./invitation-handler.component.scss'],
    standalone: false
})
export class InvitationHandlerComponent implements OnInit {

  private readonly log: AppLogger;

  // Subscription
  private routerSub: any;

  invite: InvitationResponse;
  error: any;

  // context
  invitationId: number;
  action: string;


  constructor(
    private invitationService: InvitationService,
    private route: ActivatedRoute,
    private router: Router,
    public toastService: UiToastService,
    private appLogger: AppLoggerService
  ) {
    this.log = this.appLogger.createForClass(InvitationHandlerComponent);
  }

  ngOnInit(): void {
    this.routerSub = this.route.params.subscribe(params => {
      this.invitationId = +params.id;
      this.action = params.action;
      this.loadInvite(this.invitationId);
    });
  }

  validateAction(action: string): void {
    if (action !== 'accept' && action !== 'reject') {
      this.action = '';
    } else {
      this.handleAction(this.action);
    }
  }

  handleAction(action: string): void {
    switch (action) {
      case 'accept':
        this.acceptInvitation(this.invitationId);
        break;
      case 'reject':
        this.rejectInvitation(this.invitationId);
        break;
    }
  }

  acceptInvitation(invitationId: number): void {
    this.invitationService.acceptInvitation(invitationId).subscribe(data => {
      this.toastService.success('Accepted Invitation from ' + this.invite.inviter, { durationMs: 5000 });
      this.router.navigate(['households', this.invite.household.id, 'manage']);
    }, error => {
      this.toastService.error(error.error.error, { durationMs: 5000 });
      this.router.navigate(['']);
    });
  }

  rejectInvitation(invitationId: number): void {
    this.invitationService.rejectInvitation(invitationId).subscribe(data => {
      this.toastService.error('Rejected Invitation from ' + this.invite.inviter, { durationMs: 5000 });
      this.router.navigate(['']);
    });
  }

  loadInvite(invitationId: number): void {
    this.invitationService.getInvitationById(invitationId).subscribe(data => {
      this.invite = data;
      this.validateAction(this.action);
    }, error => {
      this.log.error('Failed to load invitation', error, { invitationId });
      this.error = error.error;
      switch (error.status) {
        case 404:
          this.handleNotFound(this.invitationId);
          break;
        case 403:
          this.handleNoAccess(this.invitationId);
          break;
        default:
          this.handleUnknownError(this.invitationId);
          break;
      }
    });
  }

  handleNotFound(invitationId: number): void {
  }

  handleNoAccess(invitationId: number): void {

  }

  handleUnknownError(invitationId: number): void {

  }

}
